import {useRemoteDataSource} from "../../../../hooks/data-source";

export const useGetEstimates = (closedOrders: boolean, dateFrom: Date | null) => {
    return useRemoteDataSource('quoteID', 'estimate/dealer-list', {
        closedOrders: closedOrders,
        dateFrom: dateFrom ? dateFrom.toISOString().substring(0, 10) : undefined
    });
};
